<template>
  <div v-show="show">
    <b-modal v-model="showDeleteFileModal"
      title="Remover Arquivo"
      class="modal-primary"
      @ok="removeFile">

      Deseja remover o arquivo do processo? Ao confirmar essa ação o item não poderá ser recuperado.
    </b-modal>

    <b-card title="Processo" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Mesma Favorecido
            </span>

            <toggle-button class="mb-0"
              v-model="form.same_person"
              :width="70"
              :height="25"
              :labels="{checked: 'SIM', unchecked: 'NÃO'}"/>
          <!-- </div> -->

          <!-- <div class="switch-container"> -->
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12"
          label="Processo"
          label-for="process_id">

          <multiselect v-model="selectedProcess"
            @select="updateForm('process_id', arguments[0])"
            :allowEmpty="true"
            :options="processes"
            placeholder="Selecione um processo"
            label="company_name"
            :showLabels="false"
            track-by="id"
            :class="{
              'is-invalid': submitted && form.errors.has('process_id'),
              'is-valid': submitted && !form.errors.has('process_id')
            }"/>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="* Banco"
          label-for="bank"
          description="">

          <b-form-input id="bank"
            v-model="form.bank"
            placeholder="Banco"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('bank'),
              'is-valid': submitted && !form.errors.has('bank')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="* Agência"
          label-for="agency"
          description="">

          <b-form-input id="agency"
            v-model="form.agency"
            placeholder="Conta"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('agency'),
              'is-valid': submitted && !form.errors.has('agency')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="* Número da Conta"
          label-for="account_number"
          description="">

          <b-form-input id="account_number"
            v-model="form.account_number"
            placeholder="Conta"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('account_number'),
              'is-valid': submitted && !form.errors.has('account_number')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12"
          label="* Nome do favorecido"
          label-for="creditor_name"
          description="">

          <b-form-input id="creditor_name"
            v-model="form.creditor_name"
            placeholder="Nome do credor"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('creditor_name'),
              'is-valid': submitted && !form.errors.has('creditor_name')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="Tipo de Favorecido"
          label-for="favored_type">

          <multiselect v-model="selectedFavoredType"
            @select="updateForm('favored_type', arguments[0])"
            placeholder="Selecione o tipo"
            :allowEmpty="true"
            :options="types"
            label="name"
            :showLabels="false"
            track-by="id"
            :class="{
              'is-invalid': submitted && form.errors.has('favored_type'),
              'is-valid': submitted && !form.errors.has('favored_type')
            }"/>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="* Nome do favorecido"
          label-for="favored_name"
          description="">

          <b-form-input id="favored_name"
            v-model="form.favored_name"
            placeholder="Nome do Favorecido"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('favored_name'),
              'is-valid': submitted && !form.errors.has('favored_name')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="* Documento do favorecido"
          label-for="favored_document"
          description="">

          <b-form-input id="favored_document"
            v-model="form.favored_document"
            placeholder="Documento do Favorecido"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('favored_document'),
              'is-valid': submitted && !form.errors.has('favored_document')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12"
          label="Observações"
          label-for="observations"
          description="">

          <b-form-textarea id="observations"
            v-model="form.observations"
            placeholder="Observações Gerais"
            :rows="3"
            :max-rows="6"
            :class="{
              'is-invalid': submitted && form.errors.has('observations'),
              'is-valid': submitted && !form.errors.has('observations')
            }">
          </b-form-textarea>
        </b-form-group>

        <div class="col-12" v-if="instance.file">
          Documento enviado:

          <a :href="get(instance, '_links.download', '#!')">
            <i class="fa fa-download" v-b-tooltip.hover title="Download"></i>

            {{ instance.file.file.original_name }}
          </a>
        </div>
      </div>
      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { clone, merge, isObject, get, set } from 'lodash'
import { resolveHTTP } from '@/services/api'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          file: {}
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      showDeleteFileModal: false,
      deletableFile: null,

      locks: {
        processes: true,
        types: true
      },

      selectedProcess: null,
      processes: [],

      selectedFavoredType: null,
      types: [
        { id: 1, name: 'Pessoa Física' },
        { id: 2, name: 'Pessoa Jurídica' }
      ],

      empty: {
        file: {},
        process_id: '',
        same_person: false,
        bank: '',
        agency: '',
        account_number: '',
        creditor_name: '',
        favored_name: '',
        favored_type: null,
        favored_document: '',
        observations: '',
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps) {
        if (!get(newProps, 'form.process_id', false)) {
          this.selectedProcess = null
        }

        if (!get(newProps, 'form.favored_type', false)) {
          this.selectedFavoredType = null
        }
      },
      deep: true
    },

    selectedProcess () {
      set(this.form, 'process_id', get(this.selectedProcess, 'id', null))
    },

    selectedFavoredType () {
      set(this.form, 'favored_type', get(this.selectedFavoredType, 'id', null))
    }
  },

  computed: {
    ready () {
      return !(this.locks.processes || this.locks.types)
    }
  },

  methods: {
    get,
    set,

    updateForm (path, value, valuePath) {
      set(this.form, path, isObject(value) ? get(value || {}, valuePath || 'id', null) : value)
    },

    confirmDeleteFile (file) {
      this.deletableFile = file
      this.showDeleteFileModal = true
    },

    removeFile () {
      const self = this
      this.$Progress.start()
      self.showDeleteFileModal = false

      if (self.deletableFile === null) {
        return null
      }

      self.processSubmissionsHttp.destroy(self.deletableFile.id)
        .then(function (res) {
          self.$toasted.success('Envio removido com sucess')
          self.deletableFile = null
          self.$emit('refresh')
        })
    }
  },

  created () {
    const self = this

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(merge(self.empty, self.instance))
    } else {
      self.form.withData(clone(self.empty)).setInitialValues(clone(self.empty))
    }

    // Processes
    resolveHTTP('/bl/processes').index({ params: { _onepage: true } })
      .then(function (res) {
        self.processes = res.data.collection
        self.locks.processes = false

        self.selectedProcess = self.form.process_id
          ? self.processes.find((o) => o.id === parseInt(self.form.process_id, 10))
          : null
      })

    // Types
    self.selectedFavoredType = self.form.favored_type
      ? self.types.find((o) => o.id === parseInt(self.form.favored_type, 10))
      : self.types[0]
    self.locks.types = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/BankAccount.vue